import { Axios } from 'utils'

export const useBakersService = () => {
  const setBakersDeliveryAsDiscarded = async (bakerDeliveryId: number) => {
    try {
      const response = await Axios.put<{
        status: boolean
      }>(`/baker/deliveries/${bakerDeliveryId}/discard`)
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    setBakersDeliveryAsDiscarded,
  }
}
